import React from 'react';
import { useBrokerDetailsStore, FormField } from '../../../state/brokerDetailsStore';
import { useBrokerFieldFieldChanged } from '../../../hooks/useBrokerFieldChanged';
import { TextBox } from '@apply/components';
import { ShowIf } from '@apply/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const LastNameField: React.FC = () => {
    const lastName = useBrokerDetailsStore((s) => s.lastName);
    const updateFields = useBrokerDetailsStore((s) => s.updateFields);
    const isAdmin = useBrokerDetailsStore((s) => s.isAdmin);
    const changed = useBrokerFieldFieldChanged(FormField.LastName);

    return (
        <>
            <TextBox
                id='lastName'
                value={lastName}
                onChange={(v) => updateFields({ lastName: v })}
                label='Last Name'
                required
                width={'100%'}
                readOnly={!isAdmin}
            />
            <ShowIf showIf={changed}>
                <FontAwesomeIcon
                    icon='asterisk'
                    className='required-icon'
                />
            </ShowIf>
        </>
    );
};
